<template>
  <v-dialog
    v-model="agregaFamiliarDialog"
    width="480"
    persistent
  >
    <template #activator="{ on, attrs }">
      <v-btn
        small
        class="secondary d-inline ml-4"
        rounded
        v-bind="attrs"
        v-on="on"
        @click="agregaFamiliarDialog = true"
      >
        Agregar familiar
      </v-btn>
    </template>
    <v-card color="primary">
      <v-card-title>Agregar familiar</v-card-title>
      <v-card-text>
        <v-container>
          <v-form
            ref="familiarForm"
            v-model="familiarForm"
          >
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="familiar.nombre"
                  label="Nombre *"
                  color="secondary"
                  background-color="primary"
                  rounded
                  filled
                  dense
                  :rules="required"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="familiar.segundoNombre"
                  label="Segundo nombre"
                  color="secondary"
                  background-color="primary"
                  rounded
                  filled
                  dense
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="familiar.apaterno"
                  label="Apellido paterno"
                  color="secondary"
                  background-color="primary"
                  rounded
                  filled
                  dense
                  :rules="required"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="familiar.amaterno"
                  label="Apellido materno"
                  color="secondary"
                  background-color="primary"
                  rounded
                  filled
                  dense
                  :rules="required"
                />
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="familiar.fk_idCatParentesco"
                  rounded
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Parentesco *"
                  :items="parentesco"
                  item-value="id"
                  item-text="title"
                  :rules="required"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          text
          color="secondary"
          class="px-4"
          @click="closeDialog()"
        >
          Cerrar
        </v-btn>
        <v-btn
          rounded
          color="secondary"
          class="px-4"
          :loading="loading"
          :disabled="loading || !familiarForm"
          @click="triggerSaveFamiliar()"
        >
          Guardar familiar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    idPersonal: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      menu: false,
      familiarForm: false,
      agregaFamiliarDialog: false,
      loading: false,

      familiar: {
        nombre: '',
        segundoNombre: '',
        apaterno: '',
        amaterno: '',
        fk_idCatParentesco: null,
      },

      required: [(v) => !!v || 'Este campo es requerido.'],
    };
  },

  computed: {
    ...mapGetters('parentesco', {
      parentesco: 'getParentesco',
    }),

    ...mapGetters('sexo', {
      sexo: 'getSexo',
    }),
  },

  methods: {
    ...mapActions('solicitudes', ['saveSolicitud', 'fetchSolicitudes']),
    ...mapActions('familiares', ['saveFamiliares', 'fetchFamiliares']),

    closeDialog() {
      this.familiar = {
        nombre: '',
        segundoNombre: '',
        apaterno: '',
        amaterno: '',
        fk_idCatParentesco: null,
      };
      this.$refs.familiarForm.resetValidation();
      this.loading = false;
      this.agregaFamiliarDialog = false;
    },

    async triggerSaveFamiliar() {
      this.loading = true;

      await this.saveFamiliares({
        fk_idPersonal: this.idPersonal,
        fk_idCatParentesco: this.familiar.fk_idCatParentesco,
        nombre: this.familiar.nombre,
        segundoNombre: this.familiar.segundoNombre,
        apaterno: this.familiar.apaterno,
        amaterno: this.familiar.amaterno,
      });

      await this.fetchFamiliares(this.idPersonal);

      this.closeDialog();
    },
  },
};
</script>
